import {connect} from "react-redux";
import {API_URL} from "../../constants";
import {RoomModal} from "./RoomModal";
import {updateRoom} from "../../redux/actions";

class RoomEditModal extends RoomModal {
    constructor(props) {
        super(props);

        this.editMode = true;
        this.title = 'Edit room'
    }

    initialFormData() {
        const {room} = this.props;
        return {
            name: room.name,
            location: room.location
        };
    }

    async handleSave() {
        const {formData} = this.state;
        const {room} = this.props;

        // Build data object to send
        const data = {
            name: formData.name,
            location: formData.location,
        };
        let response = await fetch(API_URL + '/rooms/' + room.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data),
        });
        if (!response.ok && response.status !== 422) this.showAlert(response.statusText);
        else {
            let result = await response.json();
            if (response.status === 422) this.showAlert(result.message);
            else {
                /* Update room */
                this.props.updateRoom(room.id, result.data);

                /* Close modal window */
                this.handleClose();
            }
        }
    }
}

export default connect(
    null,
    {updateRoom}
)(RoomEditModal);
